import { render } from "./Properties_List.vue?vue&type=template&id=a16baa52"
import script from "./Properties_List.vue?vue&type=script&lang=js"
export * from "./Properties_List.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__